// Official university-wide profiles cross-checked against Zetech's 2026
// almanac and current university profiles. Keep this allowlist canonical so
// stale CMS values cannot send visitors to an old or unrelated account.
export const DEFAULT_SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/ZetechUniv/",
  twitter: "https://x.com/ZetechUni",
  instagram: "https://www.instagram.com/zetech_university/",
  linkedin: "https://www.linkedin.com/school/zetech-university-kenya/",
  youtube: "https://www.youtube.com/@ZetechUni",
};

export const resolveSocialLinks = () => ({ ...DEFAULT_SOCIAL_LINKS });
